import { atomWithSessionStorage } from '../../../config/jotai';

export const ufAtom = atomWithSessionStorage<undefined | number>('uf', undefined);
